import react from "react";
import { Link } from "react-router-dom";

import logo from "../../assets/Images/logo.png";

import { Component } from "react";

import { callAPI } from "../../assets/Js/backendCommunication";

import projectSettings from '../../assets/Js/projectSettings';

import style from "./ForgotPassword.module.css";

import { apiResponseToast } from "../../assets/Js/apiResponseToast";

import { Spinner } from "../../Components/Spinner/Spinner";

export default class ForgotPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      isLoading: false,
    };
  }

  submitHandler = (e) => {
    e.preventDefault();

    this.forgotPassword();
  };

  forgotPassword = async () => {
    let url = `${projectSettings.baseUrl}/users/forgotpassword`;
    let header = true;
    let type = "POST";
    let data = {};
    let token = null;

    data = {
      email: this.state.email,
    };

    let response = "";

    if (response === "") {
      this.setState({ isLoading: true });
    }

    response = await callAPI(url, header, type, JSON.stringify(data), token);

    if (response) {
      // resetting values
      console.log("forgot password Responce:", response);

      this.setState({ isLoading: false });
      if (response.type === "error") {
        console.log("Error:", response.error);
      } else if (response.type === "success") {
        apiResponseToast(response.status, "forgotpassword", response.data.message);        
      }
      response = "";
    }
  };

  render() {
    return (
      <>
        <div className={style.container}>
          <div className={`${style.formContainer} shadow`}>
            <div className="logo mt-3">
              <img src={logo} className="w-100" alt="logo" />
            </div>
            <hr />
            <form className="forms-sample p-4" onSubmit={this.submitHandler}>
              <div className="formGroup">
                <div className="mr-1">
                  <label htmlFor="userName">Email</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="userName"
                    placeholder="Email"
                    required
                    onChange={(e) => this.setState({ email: e.target.value })}
                  />
                </div>
              </div>
              <div className="mx-auto width-fit-content mt-3">
                <button
                  type="submit"
                  className="basicBtnStyle primaryBtn pl-1 pr-1"
                  disabled={this.state.isLoading}
                >
                  {this.state.isLoading ? (
                    <Spinner />
                  ) : (
                    <span>Reset Password</span>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
        <div className="cornerBtnStyle">
          <Link to="/login" className="text-white">
            <button className="basicBtnStyle secondaryBtn">Login</button>
          </Link>
        </div>
      </>
    );
  }
}
